import NavBar from "../../components/Navbar/Navbar";

function SettingsPage() {
    return(
        <section className="Settings">
            <NavBar />
            <text>
                Under construction!!
            </text>
        </section>
    )
}

export default SettingsPage